export const WHEEL_CONFIG = {
  canvasSize: 650,
  friction: 0.991,
  spinSpeedMin: 0.25,
  spinSpeedMax: 0.45,
  stopThreshold: 0.002,
  font: 'bold 30px sans-serif',
  labelColor: '#ffffff',
  spinDurationMs: 5200,
};

export type AppConfigLength = string | number;

export const toCssLength = (
  value: AppConfigLength | null | undefined,
  fallback: string
) => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return `${value}px`;
  }

  if (typeof value === 'string' && value.trim()) {
    return value.trim();
  }

  return fallback;
};

export const APP_DEFAULTS = {
  brandName: 'Alyf',
  loaderDelay: 2000,
  firestoreCollection: 'organisation',
  firestoreConfigCollection: 'config',
  firestoreConfigId: 'app',
  firestoreUsersCollection: 'users',
  firestoreEntriesCollection: 'entries',
  firestoreSpinsCollection: 'spins',
  spinPromptLabel: 'Spin The Wheel to Win a Prize',
  primaryColor: '#F3BB1A',
  accentColor: '#FFD700',
  winMessage: 'Congratulations {name}! You won: {prize}',
  failMessage: 'Sorry {name}, better luck next time.',
  accountRequiredMessage: 'Veuillez creer un compte avant de jouer.',
  taglines: [
    'Where Every Spin Sparks Joy!',
    'Wheel Brings Gifts Galore!',
    "Alyf's Wheel of Rewards!",
  ],
  carouselInterval: 10000,
  maxSpinsPerUser: 1,
  formFields: ['fullName', 'email'] as string[],
  countdownTargetDate: 0,
  campaignEnabled: true,
  campaignEndsAt: null as number | null,
  allowLocalTimerOverride: false,
  logoUrl: '',
  logoWidth: 'auto' as AppConfigLength,
  logoHeight: '40px' as AppConfigLength,
  homeWheelCenterImageUrl: '',
  homeWheelCenterImageWidth: '100%' as AppConfigLength,
  homeWheelCenterImageHeight: '100%' as AppConfigLength,
  wheelPageLogoUrl: '',
  wheelPageLogoWidth: '72%' as AppConfigLength,
  wheelPageLogoHeight: '72%' as AppConfigLength,
  wheelPageLogoBackgroundColor: '#37355D',
};

export interface AppConfig {
  brandName: string;
  loaderDelay: number;
  spinPromptLabel: string;
  primaryColor: string;
  accentColor: string;
  winMessage: string;
  failMessage: string;
  accountRequiredMessage: string;
  taglines: string[];
  carouselInterval: number;
  maxSpinsPerUser: number;
  formFields: string[];
  countdownTargetDate: number;
  campaignEnabled: boolean;
  campaignEndsAt: number | null;
  allowLocalTimerOverride: boolean;
  logoUrl: string;
  logoWidth: AppConfigLength;
  logoHeight: AppConfigLength;
  homeWheelCenterImageUrl: string;
  homeWheelCenterImageWidth: AppConfigLength;
  homeWheelCenterImageHeight: AppConfigLength;
  wheelPageLogoUrl: string;
  wheelPageLogoWidth: AppConfigLength;
  wheelPageLogoHeight: AppConfigLength;
  wheelPageLogoBackgroundColor: string;
}
